/**
 * The version of the Terms of Service and Privacy Policy that sign-up asks people to accept. The text
 * lives in the portal (`apps/web/src/legal/terms.ts`); the server records this value with every new
 * organization. Change it whenever the text changes in substance, and give notice as the terms require.
 */
export const TERMS_VERSION = '2026-09-30';
//# sourceMappingURL=terms.js.map